export default {
	setFilterWhere(state, payload) {
		state.filter.where = payload
	},
	setTemplates(state, payload) {
		state.list.templatesList = payload ?? []
	}
}
